// extracted by mini-css-extract-plugin
module.exports = {"root":"SendButton_root__2oVER","input":"SendButton_input__A_thK","button":"SendButton_button__1sfBq"};